import { isDate, format, isSameDay, isSameYear, isSameMonth, addMonths, isWithinInterval, isBefore, isAfter, addDays, startOfMonth, getYear, getMonth, startOfToday, eachDayOfInterval, startOfWeek, endOfWeek, getDay, endOfMonth, differenceInCalendarDays, eachMonthOfInterval, lastDayOfMonth, parseISO, parse } from 'date-fns';
export { addDays, addMonths, addYears, compareAsc, differenceInCalendarDays, differenceInHours, differenceInMinutes, eachDayOfInterval, eachMonthOfInterval, endOfMonth, endOfWeek, format, formatDistance, formatDistanceStrict, getWeek, isAfter, isBefore, isEqual, isSameDay, isSameMonth, isValid, lastDayOfMonth, parse, startOfMonth, startOfToday, startOfWeek, subDays } from 'date-fns';
import { useState, useEffect, useCallback, useMemo } from 'react';
export { parseFromTimeZone } from 'date-fns-timezone';

var INVALID_AMOUNT = 'Amount must be an integer';
var INVALID_DATE_OBJECT = 'Date must an instance of Date Object';
/**
 * ISO 8601 date format, eg '2021-01-01'
 */
var ISO_EXTENDED_DATE = 'yyyy-MM-dd';
/**
 *
 */
var ISO_BASIC_DATE = 'yyyyMMdd';
/**
 * Full name of the day of the week, eg 'Monday'
 */
var DAY_OF_WEEK_FULL = 'EEEE';
/**
 * Short name of the day of the week, eg 'Mon'
 
 */
var DAY_OF_WEEK_SHORT = 'EEE';
/**
 * Two digit year, eg '21'
 */
var YEAR_TWO_DIGIT = 'yy';
/**
 * Four digit year, eg '2021'
 */
var YEAR_FOUR_DIGIT = 'yyyy';
/**
 * Full name of the month, eg 'January'
 */
var MONTH_FULL = 'MMMM';
/**
 * Short name of the month, eg 'Jan'
 */
var MONTH_SHORT = 'MMM';
/**
 * Month of the year, eg '1' (no leading zero)
 */
var MONTH_OF_YEAR = 'M';
/**
 * Month and year, eg 'Jan 2021'
 */
var MONTH_YEAR = 'MMM yyyy';
/**
 * Day of the month, eg '1' (no leading zero)
 */
var DAY_OF_MONTH = 'd';
/**
 * Day of the month with ordinal, eg '1st'
 */
var DAY_OF_MONTH_ORDINAL = 'do';
/**
 * Day of the month with leading zero, eg '01'
 */
var DAY_OF_MONTH_LONG = 'dd';
/**
 * Hour in 12-hour time, eg '1' (no leading zero) with minutes.
 * eg '1:00'
 */
var HOUR_MINUTE = 'h:mm';
/**
 * Hour in 12-hour time with leading zero, eg '01' with minutes.
 * eg '01:00'
 */
var LEADING_ZERO_HOUR_MINUTE = 'hh:mm';
/**
 * Hour, minute, seconds in 12-hour (no leading zero), eg '1:00:00'
 */
var HOUR_MINUTE_SECOND = 'h:mm:ss';
/**
 * Hour, minute, and seconds in 12-hour time with leading zero, eg '01:00:00'
 
 */
var LEADING_ZERO_HOUR_MINUTE_SECOND = 'hh:mm:ss';
/**
 * Hour in 24-hour time with leading zero, eg '13' with minutes.
 */
var MILITARY_HOUR = 'HH';
/**
 * Hour in 24-hour time with leading zero, eg '13' with minutes.
 */
var MILITARY_HOUR_MINUTE = 'HH:mm';
/**
 * Hour, minute, and second in 24-hour time with leading zero, eg '13:00:00'
 */
var MILITARY_HOUR_MINUTE_SECOND = 'HH:mm:ss';
/**
 * Hour and minute in 24-hour time including leading zeros, eg '2359' or 0130
 */
var HOUR_MINUTE_API = 'HHmm';
/**
 * Hour, minute, and second in 24-hour time including leading zeros, eg '235959' or 013000
 */
var HOUR_MINUTE_SECOND_API = 'HHmmss';
/**
 * Meridian, eg 'AM' or 'PM'
   Could be 'am' or 'pm' depending on the locale
 */
var MERIDIAN = 'aaa';
/**
 * Four digit timezone offset, with no Z, eg '+0100' or '0000'
 */
var TIMEZONE_OFFSET = 'xx';
/**
 * The ISO8601 extended format with hours and minutes fields with no Z, eg '+01:00', '-03:00' or '00:00'
 */
var TIMEZONE_OFFSET_SEPARATED = 'xxx';
/**
 * Outputs date as '5:00 pm'
 */
var HOUR_MINUTE_MERIDIAN = "".concat(HOUR_MINUTE, " ").concat(MERIDIAN);
/**
 * Outputs date as '5:00pm' (no space between meridian and time)
 */
var HOUR_MINUTE_MERIDIAN_CONDENSED = "".concat(HOUR_MINUTE).concat(MERIDIAN);
// Mon, Apr 12, 2021
var WD_MONTH_DAY_YEAR = "".concat(DAY_OF_WEEK_SHORT, ", ").concat(MONTH_SHORT, " ").concat(DAY_OF_MONTH, ", yyyy");
/**
 * `01-20` for January 10, 2020
 */
var EXP_DATE_DASH = "MM-".concat(YEAR_TWO_DIGIT);
/**
 * `01/20` for January 10, 2020
 */
var EXP_DATE_SLASH = "MM/".concat(YEAR_TWO_DIGIT);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Formats a date range into a human readable form. Accepts overrides for month day and year format strings
 *
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Object} opts
 * @returns {String}
 */
function dateRangeFormatter(startDate, endDate, opts) {
    if (opts === void 0) { opts = {}; }
    if (!isDate(startDate) || !isDate(endDate)) {
        throw new Error(INVALID_DATE_OBJECT);
    }
    var defaultOpts = {
        month: 'LLLL',
        day: 'd',
        year: 'yyyy',
    };
    var _a = __assign(__assign({}, defaultOpts), opts), year = _a.year, day = _a.day, month = _a.month;
    var fullStartDate = format(startDate, "".concat(month, " ").concat(day, ", ").concat(year));
    var fullEndDate = format(endDate, "".concat(month, " ").concat(day, ", ").concat(year));
    if (isSameDay(startDate, endDate)) {
        return fullStartDate;
    }
    if (!isSameYear(startDate, endDate)) {
        return "".concat(fullStartDate, " - ").concat(fullEndDate);
    }
    if (isSameMonth(startDate, endDate)) {
        return "".concat(format(startDate, "".concat(month, " ").concat(day)), " - ").concat(format(endDate, "".concat(day, ", ").concat(year)));
    }
    // same year different month
    return "".concat(format(startDate, "".concat(month, " ").concat(day)), " - ").concat(fullEndDate);
}

/**
 * Formats `date` to a string using ISO Calendar dates extended format `yyyy-MM-dd`
 *
 * @param {Date} date
 * @returns {string}
 */
function isoExtendedFormat(date) {
    return format(date, ISO_EXTENDED_DATE);
}
/**
 * Formats `date` to a string using ISO Calendar dates basic format `yyyyMMdd`
 *
 * @param {Date} date
 * @returns {string}
 */
function isoBasicFormat(date) {
    return format(date, ISO_BASIC_DATE);
}
/**
 * Formats 'date' to a string using ISO Date time format `yyyy-MM-ddTHH:mm:ss`
 */
function isoDatetimeFormat(date) {
    return "".concat(format(date, ISO_EXTENDED_DATE), "T").concat(format(date, MILITARY_HOUR_MINUTE_SECOND));
}
/**
 * Outputs date as '5:23 or '11:50'. Does not output military time format
 * @param {Date} date
 * @returns {string}
 */
function hourMinuteFormat(date) {
    return format(date, HOUR_MINUTE);
}
/**
 * Outputs meridian as capital letters. PM or AM
 * @param {Date} date
 * @returns {string}
 */
function meridianFormat(date) {
    return format(date, MERIDIAN).toLocaleUpperCase();
}
/**
 * Outputs the four digit timezone offset, with 0000 instead of Z
 * @param {Date} date
 * @returns {string}
 */
function timeZoneOffsetFormatter(date) {
    return format(date, TIMEZONE_OFFSET);
}
function timeZoneOffsetSeparatedFormatter(date) {
    return format(date, TIMEZONE_OFFSET_SEPARATED);
}
/**
 * Outputs date as '5:00 pm'
 * @param {Date} date
 * @returns {string}
 */
function hourMinuteMeridian(date) {
    return format(date, "".concat(HOUR_MINUTE, " ").concat(MERIDIAN)).toLocaleUpperCase();
}
/**
 * Outputs date as '5:00pm' (no space between meridian and time)
 * @param {Date} date
 * @returns {string}
 */
function hourMinuteMeridianCondensed(date) {
    return format(date, "".concat(HOUR_MINUTE).concat(MERIDIAN)).toLocaleUpperCase();
}
/**
 * Outputs date as '16:30' or '09:15'
 * @param {Date} date
 * @returns {string}
 */
function militaryHourFormatter(date) {
    return format(date, MILITARY_HOUR);
}
function militaryHourMinute(date) {
    return format(date, MILITARY_HOUR_MINUTE);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function apiHourMinuteFormatter(date) {
    return format(date, HOUR_MINUTE_API);
}
function apiHourMinuteSecondFormatter(date) {
    return format(date, HOUR_MINUTE_SECOND_API);
}
function leadingZeroHourMinuteSecondFormatter(date) {
    return format(date, LEADING_ZERO_HOUR_MINUTE_SECOND);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function dayOfWeekLongFormatter(date) {
    return format(date, DAY_OF_WEEK_FULL);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function dayOfWeekShortFormatter(date) {
    return format(date, DAY_OF_WEEK_SHORT);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function monthLongFormatter(date) {
    return format(date, MONTH_FULL);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function monthShortFormatter(date) {
    return format(date, MONTH_SHORT);
}
function monthOfYearFormatter(date) {
    return format(date, MONTH_OF_YEAR);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function dayOfMonthFormatter(date) {
    return format(date, DAY_OF_MONTH);
}
function dayOfMonthLongFormatter(date) {
    return format(date, DAY_OF_MONTH_LONG);
}
function dayOfMonthOrdinalFormatter(date) {
    return format(date, DAY_OF_MONTH_ORDINAL);
}
function yearTwoDigitFormatter(date) {
    return format(date, YEAR_TWO_DIGIT);
}
function yearFourDigitFormatter(date) {
    return format(date, YEAR_FOUR_DIGIT);
}
/**
 * @param {Date} date
 * @returns {string}
 */
function monthYearFormatter(date) {
    return format(date, MONTH_YEAR);
}
/**
 * Used for lunr search. This string is used to produce ngram strings for reverse index
 * @param {Date} date
 * @returns {string}
 */
function searchStringFormatter(date) {
    return format(date, 'MMMM MMM do dd M/dd/yyyy M-dd-yyyy EEEE');
}
/**
 * Outputs date as `Wed, May 19, 2021`
 * @param {Date} date
 * @returns {string}
 */
function weekdayMonthDayYear(date) {
    return format(date, WD_MONTH_DAY_YEAR);
}
/**
 * Output date as Jul 4, 1776
 * @param {Date} date
 * @returns {string}
 */
function shortMonthDayYear(date) {
    return format(date, 'MMM d, y');
}
/**
 * @param {Date} date
 * @returns {string}
 */
function shortDayMonthDate(date) {
    return format(date, 'EEE MMM d');
}
/**
 * Takes a three part object and return string in format 'YYYY-MM-DD'.
 *
 * @param {{month: string, day: string, year: string}}
 * @returns {string} 'YYYY-MM-DD'
 */
function threePartDateToISOExtendedDateFormatter(_a) {
    var year = _a.year, month = _a.month, day = _a.day;
    return "".concat(year, "-").concat("0".concat(month).slice(-2), "-").concat("0".concat(day).slice(-2));
}

// eslint-disable-next-line default-param-last
var isInUnavailableDates = function (unavailableDates, date) {
    if (unavailableDates === void 0) { unavailableDates = []; }
    return unavailableDates.some(function (_date) { return isSameDay(date, _date); });
};
function isDateSelected(date, startDate, endDate) {
    if (startDate && endDate) {
        return isWithinInterval(date, { start: startDate, end: endDate });
    }
    return false;
}
function isFirstOrLastSelectedDate(date, startDate, endDate) {
    return !!((startDate && isSameDay(date, startDate)) || (endDate && isSameDay(date, endDate)));
}
function isStartDate(date, startDate) {
    return !!(startDate && isSameDay(date, startDate));
}
function isEndDate(date, endDate) {
    return !!(endDate && isSameDay(date, endDate));
}
function isDateBlocked(_a) {
    var date = _a.date, minBookingDate = _a.minBookingDate, maxBookingDate = _a.maxBookingDate, isDateBlockedFn = _a.isDateBlockedFn, startDate = _a.startDate, endDate = _a.endDate, _b = _a.minBookingDays, minBookingDays = _b === void 0 ? 1 : _b, _c = _a.unavailableDates, unavailableDates = _c === void 0 ? [] : _c;
    var compareMinDate = minBookingDate
        ? new Date(minBookingDate.getFullYear(), minBookingDate.getMonth(), minBookingDate.getDate(), 0, 0, 0)
        : minBookingDate;
    var compareMaxDate = maxBookingDate
        ? new Date(maxBookingDate.getFullYear(), maxBookingDate.getMonth(), maxBookingDate.getDate(), 0, 0, 0)
        : maxBookingDate;
    return !!(isInUnavailableDates(unavailableDates, date) ||
        (compareMinDate && isBefore(date, compareMinDate)) ||
        (compareMaxDate && isAfter(date, compareMaxDate)) ||
        (startDate &&
            !endDate &&
            minBookingDays > 1 &&
            isWithinInterval(date, { start: startDate, end: addDays(startDate, minBookingDays - 2) })) ||
        (isDateBlockedFn && isDateBlockedFn(date)));
}
function getDateMonthAndYear(date) {
    var today = startOfMonth(date);
    var year = getYear(today);
    var month = getMonth(today);
    return {
        year: year,
        month: month,
        date: today,
    };
}
function getCurrentYearMonthAndDate() {
    return getDateMonthAndYear(startOfToday());
}
function getInitialMonths(numberOfMonths, startDate) {
    var firstMonth = startDate ? getDateMonthAndYear(startDate) : getCurrentYearMonthAndDate();
    var prevMonthDate = firstMonth.date;
    var months = [firstMonth];
    if (numberOfMonths > 1) {
        months = Array.from(Array(numberOfMonths - 1).keys()).reduce(function (m) {
            prevMonthDate = addMonths(m[m.length - 1].date, 1);
            return m.concat([getDateMonthAndYear(prevMonthDate)]);
        }, months);
    }
    return months;
}
function getNextActiveMonth(activeMonth, numberOfMonths, counter, step) {
    var prevMonth;
    if (step) {
        prevMonth = counter > 0 ? 0 : activeMonth.length - step;
    }
    else {
        prevMonth = counter > 0 ? activeMonth.length - 1 : 0;
    }
    var prevMonthDate = activeMonth[prevMonth].date;
    return Array.from(Array(numberOfMonths).keys()).reduce(function (m) {
        if (m.length === 0) {
            prevMonthDate = addMonths(prevMonthDate, counter);
        }
        else {
            prevMonthDate = addMonths(prevMonthDate, counter >= 0 ? 1 : -1);
        }
        return counter > 0
            ? m.concat([getDateMonthAndYear(prevMonthDate)])
            : [getDateMonthAndYear(prevMonthDate)].concat(m);
    }, []);
}
function canSelectRange(_a) {
    var startDate = _a.startDate, endDate = _a.endDate, 
    // eslint-disable-next-line @typescript-eslint/no-shadow
    isDateBlocked = _a.isDateBlocked, minBookingDays = _a.minBookingDays, exactMinBookingDays = _a.exactMinBookingDays, minBookingDate = _a.minBookingDate, maxBookingDate = _a.maxBookingDate;
    var isStartDateAfterOrEqualMinDate = minBookingDate ? !isBefore(startDate, addDays(minBookingDate, -1)) : true;
    var isStartDateBeforeOrEqualMaxDate = maxBookingDate
        ? !isAfter(addDays(startDate, minBookingDays - 1), maxBookingDate)
        : true;
    if (startDate && minBookingDays === 1 && !endDate && !isDateBlocked(startDate)) {
        return true;
    }
    if ((startDate && minBookingDays > 1 && !endDate && !exactMinBookingDays) ||
        (startDate &&
            minBookingDays > 0 &&
            exactMinBookingDays &&
            isStartDateAfterOrEqualMinDate &&
            isStartDateBeforeOrEqualMaxDate) ||
        (startDate && minBookingDays > 0 && exactMinBookingDays && !minBookingDate && !maxBookingDate)) {
        return !eachDayOfInterval({ start: startDate, end: addDays(startDate, minBookingDays - 1) }).some(function (d) {
            return isDateBlocked(d);
        });
    }
    if (startDate && endDate && !exactMinBookingDays) {
        var minBookingDaysDate = addDays(startDate, minBookingDays - 1);
        if (isBefore(endDate, minBookingDaysDate)) {
            return false;
        }
        return !eachDayOfInterval({ start: startDate, end: endDate }).some(function (d) { return isDateBlocked(d); });
    }
    return false;
}
function isDateHovered(_a) {
    var date = _a.date, startDate = _a.startDate, endDate = _a.endDate, 
    // eslint-disable-next-line @typescript-eslint/no-shadow
    isDateBlocked = _a.isDateBlocked, hoveredDate = _a.hoveredDate, minBookingDays = _a.minBookingDays, exactMinBookingDays = _a.exactMinBookingDays;
    if (
    // exact min booking days
    hoveredDate &&
        minBookingDays > 1 &&
        exactMinBookingDays &&
        isWithinInterval(date, { start: hoveredDate, end: addDays(hoveredDate, minBookingDays - 1) })) {
        return !eachDayOfInterval({ start: hoveredDate, end: addDays(hoveredDate, minBookingDays - 1) }).some(function (d) {
            return isDateBlocked(d);
        });
    }
    if (
    // min booking days
    startDate &&
        !endDate &&
        hoveredDate &&
        isWithinInterval(date, { start: startDate, end: addDays(startDate, minBookingDays - 1) }) &&
        isSameDay(startDate, hoveredDate) &&
        minBookingDays > 1) {
        return !eachDayOfInterval({ start: startDate, end: addDays(startDate, minBookingDays - 1) }).some(function (d) {
            return isDateBlocked(d);
        });
    }
    if (
    // normal
    startDate &&
        !endDate &&
        hoveredDate &&
        !isBefore(hoveredDate, startDate) &&
        isWithinInterval(date, { start: startDate, end: hoveredDate })) {
        return !eachDayOfInterval({ start: startDate, end: hoveredDate }).some(function (d) { return isDateBlocked(d); });
    }
    return false;
}

var START_DATE = 'startDate';
var END_DATE = 'endDate';
function useDatepicker(_a) {
    var startDate = _a.startDate, endDate = _a.endDate, focusedInput = _a.focusedInput, minBookingDate = _a.minBookingDate, maxBookingDate = _a.maxBookingDate, onDatesChange = _a.onDatesChange, onFromChange = _a.onFromChange, onToChange = _a.onToChange, initialVisibleMonth = _a.initialVisibleMonth, _b = _a.exactMinBookingDays, exactMinBookingDays = _b === void 0 ? false : _b, _c = _a.minBookingDays, minBookingDays = _c === void 0 ? 1 : _c, _d = _a.numberOfMonths, numberOfMonths = _d === void 0 ? 2 : _d, _e = _a.firstDayOfWeek, firstDayOfWeek = _e === void 0 ? 1 : _e, _f = _a.isDateBlocked, isDateBlockedProps = _f === void 0 ? function () { return false; } : _f, _g = _a.unavailableDates, unavailableDates = _g === void 0 ? [] : _g, _h = _a.changeActiveMonthOnSelect, changeActiveMonthOnSelect = _h === void 0 ? true : _h;
    var _j = useState(function () { return getInitialMonths(numberOfMonths, initialVisibleMonth || null); }), activeMonths = _j[0], setActiveMonths = _j[1];
    var _k = useState(null), hoveredDate = _k[0], setHoveredDate = _k[1];
    var _l = useState(startDate), focusedDate = _l[0], setFocusedDate = _l[1];
    var onDateFocus = function (date) {
        setFocusedDate(date);
        if (!focusedDate || (focusedDate && !isSameMonth(date, focusedDate))) {
            setActiveMonths(getInitialMonths(numberOfMonths, date));
        }
    };
    var onDoubleChange = function (state) {
        if (onDatesChange) {
            onDatesChange(state);
        }
        if (onToChange) {
            onToChange(state);
        }
        if (onFromChange) {
            onFromChange(state);
        }
    };
    function handleKeyDown(e) {
        if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowUp') &&
            !focusedDate) {
            var activeMonth = activeMonths[0];
            onDateFocus(activeMonth.date);
            setActiveMonths(getInitialMonths(numberOfMonths, activeMonth.date));
        }
    }
    useEffect(function () {
        if (typeof window !== 'undefined') {
            if (window.addEventListener) {
                window.addEventListener('keydown', handleKeyDown);
            }
        }
        return function () {
            if (window.removeEventListener) {
                window.removeEventListener('keydown', handleKeyDown);
            }
        };
    });
    var disabledDatesByUser = function (date) {
        return isInUnavailableDates(unavailableDates, date) || isDateBlockedProps(date);
    };
    var isDateSelected$1 = function (date) { return isDateSelected(date, startDate, endDate); };
    var isFirstOrLastSelectedDate$1 = function (date) { return isFirstOrLastSelectedDate(date, startDate, endDate); };
    var isStartDate$1 = function (date) { return isStartDate(date, startDate); };
    var isEndDate$1 = function (date) { return isEndDate(date, endDate); };
    var isDateBlocked$1 = function (date) {
        return isDateBlocked({
            date: date,
            minBookingDate: minBookingDate,
            maxBookingDate: maxBookingDate,
            startDate: startDate,
            endDate: endDate,
            minBookingDays: minBookingDays,
            isDateBlockedFn: disabledDatesByUser,
        });
    };
    var isDateFocused = function (date) { return (focusedDate ? isSameDay(date, focusedDate) : false); };
    var isDateHovered$1 = function (date) {
        return isDateHovered({
            date: date,
            hoveredDate: hoveredDate,
            startDate: startDate,
            endDate: endDate,
            minBookingDays: minBookingDays,
            exactMinBookingDays: exactMinBookingDays,
            isDateBlocked: disabledDatesByUser,
        });
    };
    function onResetDates() {
        onDoubleChange({
            startDate: null,
            endDate: null,
            focusedInput: START_DATE,
        });
    }
    function onDateSelect(date) {
        if ((focusedInput === END_DATE || focusedInput === START_DATE) &&
            minBookingDays > 0 &&
            exactMinBookingDays &&
            canSelectRange({
                minBookingDays: minBookingDays,
                exactMinBookingDays: exactMinBookingDays,
                minBookingDate: minBookingDate,
                maxBookingDate: maxBookingDate,
                isDateBlocked: disabledDatesByUser,
                startDate: date,
                endDate: null,
            })) {
            onDoubleChange({
                startDate: date,
                endDate: addDays(date, minBookingDays - 1),
                focusedInput: null,
            });
        }
        else if (((focusedInput === END_DATE && startDate && isBefore(date, startDate)) ||
            (focusedInput === START_DATE && endDate && isAfter(date, endDate))) &&
            !exactMinBookingDays &&
            canSelectRange({
                minBookingDays: minBookingDays,
                isDateBlocked: disabledDatesByUser,
                startDate: date,
                endDate: null,
            })) {
            onDoubleChange({
                endDate: null,
                startDate: date,
                focusedInput: END_DATE,
            });
        }
        else if (focusedInput === START_DATE &&
            !exactMinBookingDays &&
            canSelectRange({ minBookingDays: minBookingDays, isDateBlocked: disabledDatesByUser, endDate: endDate, startDate: date })) {
            if (onDatesChange) {
                onDatesChange({
                    endDate: endDate,
                    startDate: date,
                    focusedInput: END_DATE,
                });
            }
            if (onFromChange) {
                onFromChange({
                    endDate: endDate,
                    startDate: date,
                    focusedInput: END_DATE,
                });
            }
        }
        else if (focusedInput === START_DATE &&
            !exactMinBookingDays &&
            canSelectRange({
                minBookingDays: minBookingDays,
                isDateBlocked: disabledDatesByUser,
                endDate: null,
                startDate: date,
            })) {
            onDoubleChange({
                endDate: null,
                startDate: date,
                focusedInput: END_DATE,
            });
        }
        else if (focusedInput === END_DATE &&
            startDate &&
            !isBefore(date, startDate) &&
            !exactMinBookingDays &&
            canSelectRange({ minBookingDays: minBookingDays, isDateBlocked: disabledDatesByUser, startDate: startDate, endDate: date })) {
            if (onDatesChange) {
                onDatesChange({
                    startDate: startDate,
                    endDate: date,
                    focusedInput: null,
                });
            }
            if (onToChange) {
                onToChange({
                    startDate: startDate,
                    endDate: date,
                    focusedInput: null,
                });
            }
        }
        if (focusedInput !== END_DATE &&
            (!focusedDate || (focusedDate && !isSameMonth(date, focusedDate))) &&
            changeActiveMonthOnSelect) {
            setActiveMonths(getInitialMonths(numberOfMonths, date));
        }
    }
    function onDateHover(date) {
        if (!date) {
            setHoveredDate(null);
        }
        else if (date) {
            var isNotBlocked = !isDateBlocked$1(date) || (startDate && isSameDay(date, startDate));
            var isHoveredDateAfterOrEqualMinDate = minBookingDate ? !isBefore(date, addDays(minBookingDate, -1)) : true;
            var isHoveredDateBeforeOrEqualMaxDate = maxBookingDate ? !isAfter(date, maxBookingDate) : true;
            // Exact minimal booking days
            var potentialEndDate = addDays(date, minBookingDays - 1);
            var isPotentialEndDateAfterOrEqualMinDate = minBookingDate ? !isBefore(potentialEndDate, minBookingDate) : true;
            var isPotentialEndDateBeforeOrEqualMaxDate = maxBookingDate ? !isAfter(potentialEndDate, maxBookingDate) : true;
            var isExactAndInRange = exactMinBookingDays &&
                minBookingDays > 1 &&
                isHoveredDateAfterOrEqualMinDate &&
                isHoveredDateBeforeOrEqualMaxDate &&
                isPotentialEndDateAfterOrEqualMinDate &&
                isPotentialEndDateBeforeOrEqualMaxDate;
            // Is date in range
            var isInRange = startDate &&
                !endDate &&
                !exactMinBookingDays &&
                isHoveredDateAfterOrEqualMinDate &&
                isHoveredDateBeforeOrEqualMaxDate;
            // Is start date hovered and in range
            var isMinBookingDaysInRange = minBookingDays > 1 && startDate
                ? isWithinInterval(date, { start: startDate, end: addDays(startDate, minBookingDays - 2) })
                : true;
            var isStartDateHoveredAndInRange = startDate && isSameDay(date, startDate) && isMinBookingDaysInRange;
            if (isNotBlocked && (isExactAndInRange || isInRange || isStartDateHoveredAndInRange)) {
                setHoveredDate(date);
            }
            else if (hoveredDate !== null) {
                setHoveredDate(null);
            }
        }
    }
    var goToPreviousMonths = useCallback(function () {
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, -1));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    var goToPreviousMonthsByOneMonth = useCallback(function () {
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, -1, 1));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    var goToNextMonths = useCallback(function () {
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, 1));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    var goToNextMonthsByOneMonth = useCallback(function () {
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, 1, 1));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    var goToDate = useCallback(function (date) {
        setActiveMonths(getInitialMonths(numberOfMonths, date));
        setFocusedDate(null);
    }, [numberOfMonths]);
    var goToPreviousYear = useCallback(function (numYears) {
        if (numYears === void 0) { numYears = 1; }
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, -(numYears * 12 - numberOfMonths + 1)));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    var goToNextYear = useCallback(function (numYears) {
        if (numYears === void 0) { numYears = 1; }
        setActiveMonths(getNextActiveMonth(activeMonths, numberOfMonths, numYears * 12 - numberOfMonths + 1));
        setFocusedDate(null);
    }, [activeMonths, numberOfMonths]);
    return {
        firstDayOfWeek: firstDayOfWeek,
        activeMonths: activeMonths,
        isDateSelected: isDateSelected$1,
        isDateHovered: isDateHovered$1,
        isFirstOrLastSelectedDate: isFirstOrLastSelectedDate$1,
        isStartDate: isStartDate$1,
        isEndDate: isEndDate$1,
        isDateBlocked: isDateBlocked$1,
        numberOfMonths: numberOfMonths,
        isDateFocused: isDateFocused,
        focusedDate: focusedDate,
        hoveredDate: hoveredDate,
        onResetDates: onResetDates,
        onDateHover: onDateHover,
        onDateSelect: onDateSelect,
        onDateFocus: onDateFocus,
        goToPreviousMonths: goToPreviousMonths,
        goToPreviousMonthsByOneMonth: goToPreviousMonthsByOneMonth,
        goToNextMonths: goToNextMonths,
        goToNextMonthsByOneMonth: goToNextMonthsByOneMonth,
        goToDate: goToDate,
        goToPreviousYear: goToPreviousYear,
        goToNextYear: goToNextYear,
    };
}

function useDay(_a) {
    var date = _a.date, focusedDate = _a.focusedDate, isDateSelected = _a.isDateSelected, isDateFocused = _a.isDateFocused, isFirstOrLastSelectedDate = _a.isFirstOrLastSelectedDate, isDateHovered = _a.isDateHovered, isDateBlocked = _a.isDateBlocked, onDateSelect = _a.onDateSelect, onDateFocus = _a.onDateFocus, onDateHover = _a.onDateHover;
    var onClick = useCallback(function () { return onDateSelect(date); }, [date, onDateSelect]);
    var onMouseEnter = useCallback(function () { return onDateHover(date); }, [date, onDateHover]);
    var disabled = isDateBlocked(date) && !isDateHovered(date);
    return {
        tabIndex: focusedDate === null || isDateFocused(date) ? 0 : -1,
        isSelected: isDateSelected(date),
        isSelectedStartOrEnd: isFirstOrLastSelectedDate(date),
        isWithinHoverRange: isDateHovered(date),
        disabledDate: disabled,
        onKeyDown: function (e) {
            if (e.key === 'ArrowRight') {
                onDateFocus(addDays(date, 1));
            }
            else if (e.key === 'ArrowLeft') {
                onDateFocus(addDays(date, -1));
            }
            else if (e.key === 'ArrowUp') {
                onDateFocus(addDays(date, -7));
            }
            else if (e.key === 'ArrowDown') {
                onDateFocus(addDays(date, 7));
            }
        },
        onClick: disabled ? function () { } : onClick,
        onMouseEnter: onMouseEnter,
    };
}

function getWeekdayLabels(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.firstDayOfWeek, firstDayOfWeek = _c === void 0 ? 1 : _c, _d = _b.weekdayLabelFormat, weekdayLabelFormat = _d === void 0 ? function (date) { return format(date, 'iiiiii'); } : _d;
    var now = new Date();
    var arr = eachDayOfInterval({
        start: addDays(startOfWeek(now), firstDayOfWeek),
        end: addDays(endOfWeek(now), firstDayOfWeek),
    });
    return arr.reduce(function (array, date) {
        // @ts-ignore
        array.push(weekdayLabelFormat(date));
        return array;
    }, []);
}
function getDays(_a) {
    var year = _a.year, month = _a.month, _b = _a.firstDayOfWeek, firstDayOfWeek = _b === void 0 ? 1 : _b, _c = _a.dayLabelFormat, dayLabelFormat = _c === void 0 ? function (date) { return format(date, 'dd'); } : _c;
    var date = new Date(year, month);
    var monthStart = startOfMonth(date);
    var monthStartDay = getDay(monthStart);
    var monthEnd = endOfMonth(date);
    var prevMonthDays = Array.from(Array(monthStartDay >= firstDayOfWeek ? monthStartDay - firstDayOfWeek : 6 - firstDayOfWeek + monthStartDay + 1).keys()).fill(0);
    var days = eachDayOfInterval({ start: monthStart, end: monthEnd }).map(function (dateTime) { return ({
        date: dateTime,
        dayLabel: dayLabelFormat(dateTime),
    }); });
    return __spreadArray(__spreadArray([], prevMonthDays, true), days, true);
}

var dayLabelFormatFn = function (date) { return format(date, 'dd'); };
var weekdayLabelFormatFn = function (date) { return format(date, 'eeeeee'); };
var monthLabelFormatFn = function (date) { return format(date, 'MMMM yyyy'); };
function useMonth(_a) {
    var year = _a.year, month = _a.month, _b = _a.firstDayOfWeek, firstDayOfWeek = _b === void 0 ? 1 : _b, _c = _a.dayLabelFormat, dayLabelFormat = _c === void 0 ? dayLabelFormatFn : _c, _d = _a.weekdayLabelFormat, weekdayLabelFormat = _d === void 0 ? weekdayLabelFormatFn : _d, _e = _a.monthLabelFormat, monthLabelFormat = _e === void 0 ? monthLabelFormatFn : _e;
    var days = useMemo(function () { return getDays({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, dayLabelFormat: dayLabelFormat }); }, [year, month, firstDayOfWeek, dayLabelFormat]);
    var weekdayLabels = useMemo(function () { return getWeekdayLabels({ firstDayOfWeek: firstDayOfWeek, weekdayLabelFormat: weekdayLabelFormat }); }, [firstDayOfWeek, weekdayLabelFormat]);
    return {
        days: days,
        weekdayLabels: weekdayLabels,
        monthLabel: monthLabelFormat(new Date(year, month)),
    };
}

/**
 * Returns a Date object representing the last day of a time interval that is a minimum of `minDays` long.
 * If the interval between `start` and `end` are greater than or equal to `minDays` then `end` is returned.
 *
 * @param {Date} start
 * @param {End} end
 * @param {int} minDays
 * @returns {Date}
 */
function padCalendarDays(start, end, minDays) {
    return differenceInCalendarDays(end, start) < minDays ? addDays(start, minDays) : end;
}
/**
 * Given a start date and an end date, this function will return an array of Date objects divided into months.
 *
 * @param {Date} start Start of time interval to divide into months
 * @param {Date} end End of time interval to divide into months
 */
function daysByMonth(start, end) {
    if (isSameMonth(start, end)) {
        return [__spreadArray([], eachDayOfInterval({ start: start, end: end }), true)];
    }
    var monthsOfInterval = eachMonthOfInterval({ start: start, end: end });
    var lastMonthMarker = monthsOfInterval.pop();
    var restOfMonths = monthsOfInterval.slice(1);
    var firstMonth = eachDayOfInterval({ start: start, end: lastDayOfMonth(start) });
    var months = restOfMonths.map(function (month) { return eachDayOfInterval({ start: month, end: lastDayOfMonth(month) }); });
    var lastMonth = eachDayOfInterval({ start: lastMonthMarker, end: end });
    return __spreadArray(__spreadArray([firstMonth], months, true), [lastMonth], false);
}

/**
 * Parses a date string in ISO 8601 format and returns a Date object.
 */
function parseDate(dateString) {
    return parseISO(dateString);
}
/**
 * Parses a time string like `3:30 PM` and returns a Date object. The time is
 * parsed in the context of the reference date, which defaults to the current
 * date. USE THE REFERENCE DATE PARAM!! THIS FUNCTION IS EASILY THROWN OFF BY TIMEZONE!
 */
function parseTime(timeString, format, referenceDate) {
    if (format === void 0) { format = HOUR_MINUTE_MERIDIAN; }
    if (referenceDate === void 0) { referenceDate = undefined; }
    return parse(timeString, format, referenceDate !== null && referenceDate !== void 0 ? referenceDate : new Date());
}
/**
 * Parses a date string like `01JAN` and returns a Date object. The date is
 * parsed in the context of the reference date, which defaults to the current
 * date.
 */
function parseShortCodeDate(dateStr, refDate) {
    return parse(dateStr, 'ddMMM', refDate !== null && refDate !== void 0 ? refDate : new Date());
}
/**
 * Accepts a credit card expiration date like `01-20` for Jan 2020 and returns
 * the expiration as a date. The date is advanced to the last day of the month but
 * does not take into consideration time zones.
 */
function parseCreditCardExpiration(dateStr, formatStr, refDate) {
    if (formatStr === void 0) { formatStr = EXP_DATE_DASH; }
    if (refDate === void 0) { refDate = null; }
    var firstDay = parse(dateStr, formatStr, refDate || new Date());
    return lastDayOfMonth(firstDay);
}

export { DAY_OF_MONTH, DAY_OF_MONTH_LONG, DAY_OF_MONTH_ORDINAL, DAY_OF_WEEK_FULL, DAY_OF_WEEK_SHORT, END_DATE, EXP_DATE_DASH, EXP_DATE_SLASH, HOUR_MINUTE, HOUR_MINUTE_API, HOUR_MINUTE_MERIDIAN, HOUR_MINUTE_MERIDIAN_CONDENSED, HOUR_MINUTE_SECOND, HOUR_MINUTE_SECOND_API, INVALID_AMOUNT, INVALID_DATE_OBJECT, ISO_BASIC_DATE, ISO_EXTENDED_DATE, LEADING_ZERO_HOUR_MINUTE, LEADING_ZERO_HOUR_MINUTE_SECOND, MERIDIAN, MILITARY_HOUR, MILITARY_HOUR_MINUTE, MILITARY_HOUR_MINUTE_SECOND, MONTH_FULL, MONTH_OF_YEAR, MONTH_SHORT, MONTH_YEAR, START_DATE, TIMEZONE_OFFSET, TIMEZONE_OFFSET_SEPARATED, WD_MONTH_DAY_YEAR, YEAR_FOUR_DIGIT, YEAR_TWO_DIGIT, apiHourMinuteFormatter, apiHourMinuteSecondFormatter, dateRangeFormatter, dayLabelFormatFn, dayOfMonthFormatter, dayOfMonthLongFormatter, dayOfMonthOrdinalFormatter, dayOfWeekLongFormatter, dayOfWeekShortFormatter, daysByMonth, hourMinuteFormat, hourMinuteMeridian, hourMinuteMeridianCondensed, isoBasicFormat, isoDatetimeFormat, isoExtendedFormat, leadingZeroHourMinuteSecondFormatter, meridianFormat, militaryHourFormatter, militaryHourMinute, monthLabelFormatFn, monthLongFormatter, monthOfYearFormatter, monthShortFormatter, monthYearFormatter, padCalendarDays, parseCreditCardExpiration, parseDate, parseShortCodeDate, parseTime, searchStringFormatter, shortDayMonthDate, shortMonthDayYear, threePartDateToISOExtendedDateFormatter, timeZoneOffsetFormatter, timeZoneOffsetSeparatedFormatter, useDatepicker, useDay, useMonth, weekdayLabelFormatFn, weekdayMonthDayYear, yearFourDigitFormatter, yearTwoDigitFormatter };
